export const imageUpload = {
	addImage: "Add image",
	removeImage: "Remove uploaded image",
	formatInfo: "JPG or PNG",
	ariaLabel: {
		uploadedImage: "Uploaded product image",
	},
};
